module.exports = __webpack_public_path__ + "static/media/1.51b7b888.svg";